module.exports = __webpack_public_path__ + "img/MonthlyView.e480aad9.png";